import React, { useEffect } from "react";
import { ReactComponent as WarehouseIcon } from "../../../assets/icons/modal/warehouse.svg";
import { IProduct } from "../../../types/product.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddWarehouseForm from "../forms/AddWarehouseFrom/AddWarehouseFrom";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  warehouse: IProduct[];
}

const AddWarehouseModal: React.FC<Props> = (props) => {
  const onApply = async () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <>
          <ModalTitle
            onClose={props.onClose}
            title="Додати ресурс"
            subTitle='Додайте ресурс на склад. Виберіть створений ресурс, вкажіть кількість та натисніть "Додати на склад" для збереження даних.'
            //   isLittleMargin={true}
          >
            <WarehouseIcon />
          </ModalTitle>
          <AddWarehouseForm
            warehouse={props.warehouse}
            onClose={props.onClose}
            onApply={onApply}
          />
        </>
      </div>
    </DefaultModal>
  );
};

export default AddWarehouseModal;
